import axios from "@/api/axiosAuthRequired.js"
const instaproBaseUrl = `${process.env.INSTAPRO_API_URL}api/v1/`

export const initBookedSession = (instaproToken, bookingId) => {
  try {
    const url = `${instaproBaseUrl}coach/booking/${bookingId}/initiate`
    const config = {
      headers: {
        Authorization: "Bearer " + instaproToken,
      },
    }
    const res = axios.put(url, null, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const getCoachMissedSessions = async instaproToken => {
  try {
    const url = `${instaproBaseUrl}coach/booking`
    const params = {
      from: "2021-06-01",
      missed: 1,
    }
    const config = {
      params,
      headers: {
        Authorization: "Bearer " + instaproToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    return error.response
  }
}

export const dismissMissedSession = async (instaproToken, bookingId) => {
  try {
    const url = `${instaproBaseUrl}coach/booking/${bookingId}/dismiss-notification`
    const config = {
      headers: {
        Authorization: "Bearer " + instaproToken,
      },
    }
    const res = await axios.put(url, null, config)
    return res.data
  } catch (error) {
    return error.response
  }
}

export const getBookedSessionById = async (instaproToken, bookingId) => {
  try {
    const url = `${instaproBaseUrl}coach/booking/${bookingId}`
    const config = {
      headers: {
        Authorization: "Bearer " + instaproToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    return error.response
  }
}



// WEBPACK FOOTER //
// ./src/api/coach/schedule.js